import React from 'react';
import clsx from 'clsx';

import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';

import scss from './DemoUsersTable.module.scss';

function BooleanCell({ value }) {
  return (
    <div
      className={clsx(
        scss['input_icon-container'],
        value ? scss['input_icon-container--success'] : scss['input_icon-container--error'],
      )}>
      <Icon icon={value ? ICONS.Tick : ICONS.Cross} disableCommonStyles disableCommonColors />
    </div>
  );
}

export default BooleanCell;
